// extracted by mini-css-extract-plugin
export var grayCircle = "_fj-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_fj-1";
export var selectedCircle = "_fj-2";
export var shippingOptionImage = "_fj-3";
export var shippingOptionWidgetPreview = "_fj-4";